module.exports = __webpack_public_path__ + "static/media/Waiting.d90ffd64.png";